<template>
	<div class="content">
		<div class="menu-bar">
			<div class="container">
				<Menubar></Menubar>
			</div>

		</div>
		<div id="top" class="top">
			<div class="container">
				<p class="title" v-html="l10.All_Educators_Body_Title1">

				</p>
				<p class="subtitle" v-html="l10.All_Educators_Body_Title1_Description1">

				</p>
				<template v-if='lang == "en"'>
					<a class="button" href="https://secure.todomath.com/classroom/signup" v-html="l10.All_Educators_Body_Title1_button1" target="_blank"></a>
					<a class="button white" href="https://secure.todomath.com/educator/school_quote" v-html="l10.All_Educators_Body_Title1_button2" target="_blank"></a>
				</template>
				<template v-else-if='lang == "ko"'>
					<div class='ko-buttons'>
						<a class="button white" href="https://docs.google.com/forms/d/e/1FAIpQLScsvfcf7FBYdIKqxlwyatHpCn1jfAxzddb1zZZBQPdsoppX-w/viewform?usp=sf_link" target="_blank" v-html="l10.All_Educators_Body_Title1_button1"></a>
					</div>
				</template>

				
			</div>
		</div>
		<div id="article1">
			<div class="container">
				<p class="title" v-html="l10.All_Educators_Body_Title2">

				</p>
				<p class="title-description"  v-html="l10.All_Educators_Body_Title2_Description1">

				</p>
				<div>
					<div class="article">
						<p class="sub-title" v-html="l10.All_Educators_Body_Title2_Subtitle1">

						</p>
						<p class="description list"  v-html="l10.All_Educators_Body_Title2_Subtitle1_Description1">

						</p>
						<p class="description list"  v-html="l10.All_Educators_Body_Title2_Subtitle1_Description2">

						</p>
						<p class="description list"  v-html="l10.All_Educators_Body_Title2_Subtitle1_Description3">

						</p>

					</div>
					<div class="img">
						<template v-if='lang != "ko"'>
							<img src="@/assets/educator/img-educator-feature-1.png"
								srcset="@/assets/educator/img-educator-feature-1@2x.png 2x,
										@/assets/educator/img-educator-feature-1@3x.png 3x">
						</template>
						<template v-else>
							<img src="@/assets/educator/img-educator-feature-2_ko.png">
						</template>
					</div>

				</div>

			</div>
		</div>

		<div id="article2" :class='lang'>
			<div class="container">

				<div class="article">
					<p class="sub-title" v-html="l10.All_Educators_Body_Title2_Subtitle2">

					</p>
					<p class="description list white"  v-html="l10.All_Educators_Body_Title2_Subtitle2_Description1">

					</p>
					<p class="description list white"  v-html="l10.All_Educators_Body_Title2_Subtitle2_Description2">

					</p>
				</div>



			</div>
		</div>
<div id="article2-1">
    <div class="container">
        <div>
            <div class="article">
				<template v-if='lang != "ko"'>
					<p class="sub-title">Remote Access for <br>
                    	At-Home Learning
					</p>
					<p class="description list white">
						Allow students to access Todo Math for the Classroom from a home tablet or smartphone
					</p>
					<p class="description list white">
						Teachers can review students’ learning progress from the teacher dashboard
					</p>
				</template>
                <template v-if='lang == "ko"'>
					<p class="sub-title">가정에서도 플레이가 가능한 원격 모드
					</p>
					<p class="description list white">
						가정에서 태블릿이나 스마트폰을 통해<br>토도수학 학급 모드 이용
					</p>
					<p class="description list white">
						선생님 대시보드를 통해 학생들의 진도 확인 가능
					</p>
				</template>
            </div>
            <div class="img">
                <img src="@/assets/educator/img-educator-feature-3.png" srcset="@/assets/educator/img-educator-feature-3@2x.png 2x,
                @/assets/educator/img-educator-feature-3@3x.png 3x" class="img_educator_feature_3">
            </div>
        </div>
    </div>
</div>
		<div id="article3" class="container">
			<p class="title" v-html="l10.All_Educators_Body_Title3">

			</p>
			<p class="title-description" v-html="l10.All_Educators_Body_Title3_Description1">

			</p>
			<div class="why-todo-img">
				<div>
					<img src="@/assets/educator/img-educator-why-1.png"
					     srcset="@/assets/educator/img-educator-why-1@2x.png 2x,
					             @/assets/educator/img-educator-why-1@3x.png 3x">
					<p v-html="l10.All_Educators_Body_Title3_Subtitle1">

					</p>
				</div>
				<div>
					<img src="@/assets/educator/img-educator-why-2.png"
					     srcset="@/assets/educator/img-educator-why-2@2x.png 2x,
					             @/assets/educator/img-educator-why-2@3x.png 3x" >
					<p v-html="l10.All_Educators_Body_Title3_Subtitle2">

					</p>
				</div>
				<div>
					<img src="@/assets/educator/img-educator-why-3.png"
					     srcset="@/assets/educator/img-educator-why-3@2x.png 2x,
					             @/assets/educator/img-educator-why-3@3x.png 3x">
					<p v-html="l10.All_Educators_Body_Title3_Subtitle3">

					</p>
				</div>
				<div>
					<img src="@/assets/educator/img-educator-why-4.png"
					     srcset="@/assets/educator/img-educator-why-4@2x.png 2x,
					             @/assets/educator/img-educator-why-4@3x.png 3x">
					<p v-html="l10.All_Educators_Body_Title3_Subtitle4">

					</p>
				</div>
			</div>


		</div>
		<div id="article4" class="container">
			<p class="sub-title" v-html="l10.All_Educators_Body_Title1_Subtitle1">
			</p>
			<div class="subjects">
				<div>
					<p v-html="l10.All_Educators_Body_Title1_Quote1">
					</p>
					<p v-html="l10.All_Educators_Body_Title1_Quote1_source1">
					</p>
				</div>
				<div>
					<p v-html="l10.All_Educators_Body_Title1_Quote2">
					</p>
					<p v-html="l10.All_Educators_Body_Title1_Quote2_source1">
					</p>
				</div>
				<div>
					<p v-html="l10.All_Educators_Body_Title1_Quote3">
					</p>
					<p v-html="l10.All_Educators_Body_Title1_Quote3_source1">
					</p>
				</div>
			</div>

		</div>
		<div id="article5" v-if='lang != "ko"'>
			<div class="container">
				<p class="title" v-html="l10.All_Educators_Body_Title4">

				</p>
				<p class="title-description" v-html="l10.All_Educators_Body_Title4_Description1">

				</p>
				<div class="download">
					<div>
						<div>
							<p v-html="l10.All_Educators_Body_Title4_Subtitle1"></p>
							<a :href="getFile('2018_TodoMath_BacktoSchool_Flyer.pdf')" v-html="l10.All_Educators_Body_Title4_Button1" download></a>
						</div>
						<div>
							<p v-html="l10.All_Educators_Body_Title4_Subtitle2"></p>
							<a :href="getFile('Sample_Parent_Email_Color.docx')" v-html="l10.All_Educators_Body_Title4_Button2" download></a>
							<a :href="getFile('Sample_Parent_Email_BlackWhite-2.docx')" v-html="l10.All_Educators_Body_Title4_Button3" download></a>
						</div>
					</div>
					<div>
						<div>
							<p v-html="l10.All_Educators_Body_Title4_Subtitle3"></p>
							<a :href="getFile('2018_Parent_Resource_Guide.pdf')"  v-html="l10.All_Educators_Body_Title4_Button1" download></a>

						</div>
						<div>
							<p v-html="l10.All_Educators_Body_Title4_Subtitle4"></p>
							<a :href="getFile('2018_TodoMath_ActivityBook_Final.pdf')"  v-html="l10.All_Educators_Body_Title4_Button2" download></a>

						</div>
					</div>
				</div>
			</div>
		</div>
		<div id="article6">
			<div class="container">
				<p class="title" v-html="l10.All_Educators_Body_Title5">

				</p>
				<template v-if='lang == "en"'>
					<a class="button" href="https://secure.todomath.com/classroom/signup" target="_blank" v-html="l10.All_Educators_Body_Title1_button1"></a>
					<a class="button"  href="https://secure.todomath.com/educator/school_quote" target="_blank" v-html="l10.All_Educators_Body_Title1_button2"></a>
				</template>
				<template v-else-if='lang == "ko"'>
					<div class='ko-buttons'>
						<a class="button" href="https://docs.google.com/forms/d/e/1FAIpQLScsvfcf7FBYdIKqxlwyatHpCn1jfAxzddb1zZZBQPdsoppX-w/viewform?usp=sf_link" target="_blank" v-html="l10.All_Educators_Body_Title1_button1"></a>
					</div>
				</template>

			</div>
		</div>
		<div class="container">
			<Footer>
			</Footer>
		</div>


	</div>

</template>
<script>
import Menubar from '../../components/menubar/LaptopLayout.vue'
import Footer from '@/components/footer/FooterLaptop.vue'


export default {
  name: 'FeaturesLaptopFrame',
	components:{ Menubar,Footer},
	methods:{
		getFile(file){
			return require('@/assets/files/'+file);
		}
	},
	data () {
			const text = require('../../text/educator/laptop.js').default;
			const l10n = text[this.$store.state.lang]?text[this.$store.state.lang]:text['en'];
	    return {
			l10:l10n,
			lang: this.$store.state.lang,
	    }
	},
	// updated(){
	// 	for(var i=0; i<this.$el.querySelectorAll('p.open').length; i++){
	// 		this.$el.querySelectorAll('p.open')[i].classList.remove('open');
	// 	}
	// }
}
</script>
<style  scoped>
.content{
	width:100%;
	overflow: hidden;
}

.container{
	margin: 0 auto;
	height: auto;
	min-height: 100px;
		width:1024px;
}
p.list::before{
	content:"";
	width: 16px;
  height: 6px;
  border-radius: 3px;
  background-color: #41403e;
  display: inline-block;
	position: relative;
  transform: translateY(-50%);
  margin-right:8px;
  
}
p.list.white::before{
  background-color: #fff;
}

.title{
	font-size: 76px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.16;
  letter-spacing: -3px;
  text-align: center;
  color: #41403e;

}
.title-description{
	font-size: 32px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: -0.7px;
  text-align: center;
  color: #41403e;

}
.title ~ .title-description{
	margin-top:13px;
}
.sub-title{
	width: 100%;
	font-size: 42px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: -1.8px;

}
.description{
	margin-top:28px;
	width: 100%;
	font-size: 22px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.45;
  letter-spacing: -0.9px;
}
.sub-title ~ .description{
	margin-top:31px;
}
#top{
	width: 100%;
	height: 600px;
	background-image: url('../../assets/educator/img-educator-top-bg@2x.png');
	background-size: 2400px auto;
	background-position:center;
	color:#fff;
	padding-top: 180px;
	padding-left: 11px;
	text-align: left;
}

#top .title{
	font-size: 56px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.14;
  letter-spacing: -1.8px;
  color: #ffffff;
  text-align: left;

}
#top .subtitle{
	font-size: 22px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.7px;
  color: #ffffff;
  margin-top: 13px;
}
#top .button:first-of-type{
	margin-top: 49px;
}
#top .button{
	display: flex;
	justify-content: center;
	align-items:center;
	width: 317px;
	  height: 64px;
	  object-fit: contain;
	  border-radius: 32px;
	  border: solid 3px #41403e;
	  font-size: 22px;
	 font-weight: normal;
	 font-style: normal;
	 font-stretch: normal;
	 line-height: normal;
	 letter-spacing: -0.7px;
	 text-align: center;
	 color: #41403e;
	 margin-top:16px;
}
#top .button.white{
	border-color: #fff;
	color:#fff;
}

#article1 {
	padding-top:120px;
	height: 1111px;
	overflow: hidden;
}


#article1>.container>div{
	display: flex;
	width: 100%;
	margin-top:126px;

}
#article1>.container>div .article{
	width:480px;
	display: flex;
	flex-direction: column;
	justify-content: center;
}


#article1>.container>div .img{
	width:calc(100% - 480px);
}
#article1>.container>div .img>img{
	width: 1092px;
  	height: 692px;
}

.ko-buttons {
	height: 144px;
	display:flex;
	align-items: center;
	margin-top: 45px;
}
.ko-buttons a {
	margin-top: 0px !important;
}

#article2{
	background-image:url('../../assets/educator/img-educator-feature-2@2x.jpg');
	height:836px;
	background-size: 2400px auto;
	background-position: center;
	padding-top:160px;
	color:#fff;
}

#article2 .article{
	float: right;
	margin-right: 11px;
}


#article2-1 {
    height: 720px;
    width: 2400 auto;
    background-color: #75bd40;
    padding-top: 130px;
	padding-bottom: 120px;
	color: #FFF;
}

#article2-1 .article {
    width: 500px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    margin-top: 30px;
}

#article2-1 .container > div {
    display: flex;
    width: 100%;
}

#article2-1 > .container > div .img > img {
    width: 512px;
    height: 470px;
}

#article2-1 p.list.white::before {
	background-color: #fff;
    position: absolute;
    transform: scale(0.8) translateX(-30px) translateY(15px);
}

#article2-1 .description {
	margin-left: 20px;
}


#article3{
	padding-top: 100px;
}
#article3::after{
	content:"";
	width:328px;
	position:absolute;
	border-bottom: 0;
	border-bottom: solid 1px #e6e6e6;
	left:50%;
	transform: translateX(-50%);
}
#article3 .why-todo-img{
	width: 100%;
	display: flex;
	margin-top:120px;
	font-size: 22px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.45;
  letter-spacing: -0.5px;
  text-align: center;
  color: #41403e;
  padding-bottom: 80px;

}

#article3 .why-todo-img>div{
	width: 25%;
	display: flex;
	flex-direction: column;

}
#article3 .why-todo-img>div>*{
	align-self: center;
}
#article3 .why-todo-img>div img {
	/* width: 128px; */
    /* height: 110px; */
    margin-bottom: 18px;
}

#article4{
	padding-top:60px;
	padding-bottom: 120px;
	text-align: center;
}


#article4 .subjects{
	display: flex;
	justify-content: space-between;
	margin-top: 62px;
}
#article4 .subjects>div{
	width: 308px;
}
#article4 .subjects>div p:first-of-type{
	font-size: 18px;
  font-weight: normal;
  font-style: italic;
  font-stretch: normal;
  line-height: 1.78;
  letter-spacing: -0.8px;
  text-align: center;
  color: #41403e;
  margin-bottom: 16px;
}
#article4 .subjects>div p:last-of-type{
	font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.56;
  letter-spacing: normal;
  text-align: center;
  color: #999999;
}
#article5{
	background-color: #fffcf7;
	padding-top:100px;
	padding-bottom: 123px;
}
#article5 .download{
	margin-top:83px;
}
#article5 .download>div{
	display: flex;
	justify-content: space-between;
	padding:0 11px;

}
#article5 .download>div~div{
	margin-top:63px;
}
#article5 .download>div>div{
	width: 412px;
}
#article5 .download>div>div p{
	font-size: 32px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: -0.7px;
  color: #41403e;
}
#article5 .download>div>div p~a{
	padding-top: 13px;
}
#article5 .download>div>div a{
	font-size: 22px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.45;
  letter-spacing: -0.5px;
  color: #42c0ff;
  display: block;

}
#article5 .download>div>div a~a{
	padding-top:8px;
}
#article6{
	background-image: url('../../assets/educator/img-educator-try-bg@2x.jpg');
	background-size: 2400px auto;
	height: 630px;
	background-position: center;
	padding-top:100px;
	color:#fff;
}
#article6 .contaner{
	padding-left:11px;
}
#article6 .title{
	color:#fff;
	text-align: left;
	margin-bottom: 56px;
	font-size: 56px;
}
#article6 .button{
	display: flex;
	justify-content: center;
	align-items:center;
	width: 317px;
	  height: 64px;
	  object-fit: contain;
	  border-radius: 32px;
	  border: solid 3px #fff;
	  font-size: 22px;
	 font-weight: normal;
	 font-style: normal;
	 font-stretch: normal;
	 line-height: normal;
	 letter-spacing: -0.7px;
	 text-align: center;
	 color: #fff;
	 margin-top:16px;
	 background-color: rgba(0, 0, 0, 0.3);
}
#article6 .button~.button{
	margin-top:16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/educator/EducatorLaptop.vue